/* Native interactions for the exact observed V3C design. No Replo runtime. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const config = JSON.parse(document.getElementById('burn-native-config').textContent);
  const afterHero = callback => {
    if (!config.prioritizeHero) { callback(); return; }
    const schedule = () => requestAnimationFrame(() => requestAnimationFrame(() => {
      if ('requestIdleCallback' in window) requestIdleCallback(callback, {timeout:1500});
      else setTimeout(callback,0);
    }));
    const hero = document.querySelector('img[fetchpriority="high"]');
    if (!hero || hero.complete) schedule();
    else {
      const ready = () => { hero.removeEventListener('load',ready); hero.removeEventListener('error',ready); schedule(); };
      hero.addEventListener('load',ready,{once:true});
      hero.addEventListener('error',ready,{once:true});
    }
  };
  const supplies = [
    {n:1,otp:29.99,sub:23.99,variant:39752926527749,plan:451477765},
    {n:3,otp:74.99,sub:59.99,variant:39752926593285,plan:451510533},
    {n:5,otp:119.99,sub:95.99,variant:39754632921349,plan:451543301}
  ];
  const money = x => '$' + x.toFixed(2);
  const floorMoney = x => money(Math.floor((x + 1e-8) * 100) / 100);
  const titles = ['The Anti-Diet Guide','Movement Guide','Travel Pill Organizer','Collagenic® Burn PM'];
  const dialog = $('.burn-card-dialog');
  // Small local data is available before interaction, independently of reviews.
  const gifts = JSON.parse($('#burn-gift-data').textContent);
  let checkoutBusy = false;
  let checkoutButton;
  const resetCheckout = () => {
    if (!checkoutBusy) return;
    checkoutBusy = false;
    $$('.bc-buy, .burn-offer-card input').forEach(e => e.disabled = false);
    checkoutButton?.removeAttribute('aria-busy');
    checkoutButton?.querySelector('.bc-spinner')?.remove();
  };
  dialog.addEventListener('close', resetCheckout);
  window.addEventListener('pageshow', resetCheckout);
  const shippingFormat = new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});
  function shippingStatus(now = new Date()) {
    const parts = d => Object.fromEntries(shippingFormat.formatToParts(d).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
    const p=parts(now),today=Date.UTC(p.year,p.month-1,p.day),ship=new Date(today);
    if(ship.getUTCDay()===0||p.hour>=15)ship.setUTCDate(ship.getUTCDate()+1);
    while(ship.getUTCDay()===0)ship.setUTCDate(ship.getUTCDate()+1);
    const guess=Date.UTC(ship.getUTCFullYear(),ship.getUTCMonth(),ship.getUTCDate(),15),q=parts(new Date(guess));
    const offset=guess-Date.UTC(q.year,q.month-1,q.day,q.hour,q.minute,q.second),total=Math.max(0,Math.floor((guess+offset-now.getTime())/1000));
    const days=Math.round((ship.getTime()-today)/86400000),label=days===0?'today':days===1?'tomorrow':ship.toLocaleDateString('en-US',{timeZone:'UTC',weekday:'long'});
    return {message:'Ships '+label+', '+ship.toLocaleDateString('en-US',{timeZone:'UTC',month:'long',day:'numeric'}),timer:Math.floor(total/3600)+'hr '+Math.floor(total%3600/60)+'min '+total%60+'sec'};
  }
  const shippingNodes=$$('.bc-ship-message'),timers=$$('.bc-ship-timer');
  let offerVisible=false;
  const offerObserver=new IntersectionObserver(entries=>{offerVisible=entries.some(e=>e.isIntersecting);if(offerVisible)updateShipping()},{rootMargin:'200px'});
  offerObserver.observe($('.bc-grid'));
  const updateShipping=()=>{if(document.hidden||!offerVisible)return;const s=shippingStatus();shippingNodes.forEach(e=>{if(e.textContent!==s.message)e.textContent=s.message});timers.forEach(e=>e.textContent=s.timer)};
  if (!config.isolationPage) { offerVisible=true;updateShipping();offerVisible=false; }
  setInterval(updateShipping,1000);

  $$('.burn-offer-card').forEach((card,i)=>{
    const c=supplies[i];
    const render=()=>{
      const sub=$('input:checked',card).value==='sub',price=sub?c.sub:c.otp;
      $('.bc-saving',card).textContent='| SAVE '+Math.round((1-price/(c.n*49.99))*100)+'%';
      $('.bc-price strong',card).textContent=money(price);
      $('.bc-unit',card).textContent=floorMoney(price/c.n)+' per bottle';
      $('.bc-day',card).textContent=floorMoney(price/(c.n*30))+' per day';
      $('.bc-buy',card).textContent='BUY NOW • '+money(price);
      $('.bc-terms',card).hidden=!sub;
    };
    card.addEventListener('change',render);
    card.addEventListener('click',e=>{
      const info=e.target.closest('[data-gift]');
      if(info){
        const j=Number(info.dataset.gift);
        dialog.innerHTML='<button type="button" class="bc-close" data-close-gift aria-label="Close gift details">×</button><h3 id="burn-card-gift-title">'+titles[j]+'<small>(worth '+money(j===3?39.99:j===2?14.99:9.99)+')</small></h3><div>'+gifts[j].html+'</div><img class="bc-dialog-image" src="'+gifts[j].img+'" alt="'+titles[j]+'">';
        dialog.showModal();
      }
    });
    $('.bc-buy',card).addEventListener('click',async()=>{
      if(checkoutBusy)return;
      checkoutBusy=true;
      checkoutButton=$('.bc-buy',card);
      checkoutButton.setAttribute('aria-busy','true');
      const spinner=document.createElement('span');spinner.className='bc-spinner';spinner.setAttribute('aria-hidden','true');checkoutButton.append(spinner);
      $$('.bc-buy, .burn-offer-card input').forEach(e=>e.disabled=true);
      const sub=$('input:checked',card).value==='sub';
      const errorBox=$('.bc-error',card);errorBox.hidden=true;
      const root=config.root.endsWith('/')?config.root:config.root+'/';
      const post=async(path,data)=>{
        const response=await fetch(root+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Please try again.');
        return result;
      };
      try{
        await post('cart/clear.js',{});
        const burn={id:c.variant,quantity:1,properties:{_burn_offer:'cards-sep29',_burn_supply:String(c.n)}};
        if(sub)burn.selling_plan=c.plan;
        const giftIds=[39753583264005,39753583231237,39743463293189,39753991028997];
        await post('cart/add.js',{items:[burn,...giftIds.slice(0,i+2).map(id=>({id,quantity:1,properties:{_burn_offer:'cards-sep29',_burn_gift:'welcome'}}))]});
        const price=sub?c.sub:c.otp;
        window._upstack&&window._upstack('track','add_to_cart',{value:price,currency:'USD',items:[{id:'6702443004165',variant:String(c.variant),quantity:1,name:'Collagenic Burn - '+c.n+' Month Supply',price}]});
        window.location.assign(root+'checkout'+(sub?'':'?discount=BURN-CARDS-'+c.n+'-SEP29'));
      }catch(error){
        errorBox.textContent=error.message||'Unable to continue. Please try again.';
        errorBox.hidden=false;resetCheckout();
      }
    });
    if (!config.isolationPage || $('input:checked',card).value === 'sub') render();
  });
  dialog.addEventListener('click',e=>{if(e.target===dialog||e.target.closest('[data-close-gift]'))dialog.close()});
  document.addEventListener('click',e=>{
    const b=e.target.closest('button,[role=button]');if(!b)return;
    if(b.textContent.trim()==='CLAIM OFFER')$('.bc-grid').scrollIntoView({behavior:'smooth',block:'start'});
    if(b.closest('.bc-reviews'))$('#judgeme_product_reviews').scrollIntoView({behavior:'smooth',block:'start'});
    if(b.textContent.trim()==='Full Ingredient Panel')$('#ingredient-dialog').showModal();
  });
  const ingredient=$('#ingredient-dialog');
  ingredient.addEventListener('click',e=>{if(e.target===ingredient||e.target.closest('[role=button]'))ingredient.close()});

  $$('[data-replo-collapsible]').forEach(row=>{
    const trigger=$('[aria-controls]',row),content=document.getElementById(trigger.getAttribute('aria-controls'));
    const toggle=()=>{const open=trigger.getAttribute('aria-expanded')!=='true';trigger.setAttribute('aria-expanded',String(open));row.dataset.state=open?'open':'closed';content.hidden=!open;};
    trigger.addEventListener('click',toggle);
    trigger.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle()}});
  });

  $$('[data-replo-carousel]').forEach(carousel=>{
    const track=$('[data-replo-part="slide-track"]',carousel),slides=$$('[data-replo-part="slide"]',track);
    const prev=$('[data-direction="previous"]',carousel),next=$('[data-direction="next"]',carousel),dots=$$('button[aria-label^="Go to slide"]',carousel);
    let index=0,startX=0;
    const update=()=>{
      const gap=parseFloat(getComputedStyle(track).gap)||0,w=slides[0].getBoundingClientRect().width+gap;
      const viewport=$('[data-replo-part="slides"]',carousel).getBoundingClientRect().width;
      const perPage=Math.max(1,Math.round((viewport+gap)/w)),max=Math.max(0,slides.length-perPage);
      index=Math.min(max,Math.max(0,index));
      track.style.transform=`translate3d(${-index*w}px,0,0)`;
      if(prev)prev.disabled=index===0;if(next)next.disabled=index===max;
      slides.forEach((s,i)=>{s.dataset.isActive=String(i>=index&&i<index+perPage);s.dataset.isTarget=String(i===index)});
      dots.forEach((d,i)=>{d.dataset.isActive=String(i===index);d.setAttribute('aria-current',i===index?'true':'false')});
      const status=$('[aria-live]',carousel);if(status)status.textContent=`Slide ${index+1} of ${slides.length}`;
    };
    prev?.addEventListener('click',()=>{index--;update()});next?.addEventListener('click',()=>{index++;update()});
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{index=i;update()}));
    track.addEventListener('touchstart',e=>startX=e.touches[0].clientX,{passive:true});
    track.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>40){index+=dx<0?1:-1;update()}},{passive:true});
    let pendingFrame=0,nearViewport=!config.prioritizeHero;
    const scheduleUpdate=()=>{if(nearViewport&&!pendingFrame)pendingFrame=requestAnimationFrame(()=>{pendingFrame=0;update()})};
    const watch=()=>{
      new ResizeObserver(scheduleUpdate).observe(carousel);
      if(config.prioritizeHero && 'IntersectionObserver' in window){
        new IntersectionObserver(entries=>{nearViewport=entries.some(e=>e.isIntersecting);if(nearViewport)scheduleUpdate()},{rootMargin:'0px 0px 100px 0px'}).observe(carousel);
      }else{nearViewport=true;scheduleUpdate()}
    };
    afterHero(watch);
  });

  const startObservation=()=>{
    const template=document.getElementById('burn-delayed-observation');
    if(!template)return;
    for(const source of template.content.querySelectorAll('script')){
      const script=document.createElement('script');
      for(const attribute of source.attributes)script.setAttribute(attribute.name,attribute.value);
      script.textContent=source.textContent;document.head.appendChild(script);
    }
    template.remove();
  };
  const scheduleObservation=()=>setTimeout(()=>{
    if('requestIdleCallback' in window)requestIdleCallback(startObservation,{timeout:2000});
    else startObservation();
  },3000);
  if(document.readyState==='complete')scheduleObservation();
  else window.addEventListener('load',scheduleObservation,{once:true});
})();

